import { DateTime } from 'luxon';
export enum DayMomentValidation {
  start = 'start',
  end = 'end',
}
export type TimeSetter = Record<DayMomentValidation, (date: DateTime) => DateTime>;
